export default {
    dashboard_fleet_vehicle_management: ['dashboard_fleet_vehicle_management'],
    dashboard_fleet_operation: ['dashboard_fleet_operation'],
    dashboard_direction_of_fleet: ['dashboard_direction_of_fleet'],

    dashboard_operation_shiment_leg: ['dashboard_operation_shiment_leg'],
    dashboard_sale: ['dashboard_sale']
}
